import { Component, OnInit, Renderer2, ElementRef, ViewChild } from '@angular/core';
import {Router, NavigationExtras, Event, NavigationStart, NavigationError} from "@angular/router"
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '@app/_services';
import {ConfirmDialogService} from '../confirm-dialog/confirm-dialog/confirm-dialog.service';  

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
declare var $:any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  user_role_id: number=0;
  isAdmin:boolean = false;
  isAdmin_only_view:boolean  = false;
  user_isView:number =0;
  userName: string = "";
  userRole: string ="";
  userImage :string = "";
  
  @ViewChild("allLI") liView: ElementRef;
  message:string;

  constructor(private router: Router, 
      private renderer: Renderer2, 
      private data: DataService,
      private modalService: NgbModal,
      private confirmDialogService: ConfirmDialogService) { }

      ngOnInit(): void {
         this.data.currentMessage.subscribe(message => this.message = message)
  
          this.data.getUserInfo().subscribe(userInfo => {
            this.loadUserInfo();
          })
  
          this.loadUserInfo();
  
          this.data.currentMessage.subscribe(message => this.message = message)
          $(".btn-spin").hover(function(){
            $(".rotates").toggleClass("down"); 
          });
          
          $(".list-group-item").click(function() {        
            var listItems = $(".list-group-item"); 
            
          for (let i = 0; i < listItems.length; i++) { 
            listItems[i].classList.remove("active"); 
          } 
            // Add 'active' tag for currently selected item 
          this.classList.add("active"); 
      }); 
    }

   loadUserInfo(){
    var userdata = localStorage.getItem('userInformation');
    var parsedUserData = JSON.parse(userdata);
    if(parsedUserData) {
      this.userName = parsedUserData.first_name+" "+parsedUserData.last_name;
      this.userRole = parsedUserData.role_name;
      this.userImage = parsedUserData.profile_picture;
      this.user_role_id = parsedUserData.role_id;
      this.user_isView = parsedUserData.is_view;
      if(this.user_role_id==1 || this.user_role_id ==2){
        this.isAdmin = true;
      }else{
        this.isAdmin = false
      }
     if(this.user_role_id == 2)
      if(this.user_isView == 1){
          this.isAdmin_only_view = true;
        }else{
         this.isAdmin_only_view = false;
        }
      }
    }

  newMessage() {
    
  }

  ngAfterViewInit() {
        $(document).ready(function () {
            $('#sidebarCollapse').on('click', function () {
                $('#sidebar').toggleClass('active');
            });
        });

        this.router.events.subscribe((event: Event) => {
          if (event instanceof NavigationStart) {
              console.log("Sidebar start " + event);
              if(event.url == "/" || event.url == "/dashboard") {
                this.data.changeMessage("/ Dashboard")
              } else if(event.url == "/addinstore") {
                this.data.changeMessage("/ Add Instore") 
              } else if(event.url == "/bulkcampaign") {
                this.data.changeMessage("/ Bulk Campaign") 
              } else if(event.url == "/addhoarding") {
                this.data.changeMessage("/ Add Hoarding") 
              } else if(event.url == "/bulkhoarding") {
                this.data.changeMessage("/ Bulk upload Hoarding") 
              } else if(event.url == "/bulkupload") {
                this.data.changeMessage("/ bulk upload instore") 
              } else if(event.url == "/report") {
                this.data.changeMessage("/ Reports") 
              } else if(event.url == "/instorelist") {
                this.data.changeMessage("/ Instore List") 
              } else if(event.url == "/hoardinglist") {
                this.data.changeMessage("/ Hoarding List") 
              } else if(event.url == "/usermanagement") {
                this.data.changeMessage("/ Admin") 
              }
    }
          if (event instanceof NavigationError) {
              console.error(event.error);
          }

      });
  }

  gotoAddInstore(e) {

    this.data.changeMessage("/ Add Store")

    localStorage.setItem('user', "userdata");

    let navigationExtras: NavigationExtras = {
      queryParams: {
          "user": JSON.stringify("moorthy")
      }
    };

    this.router.navigate(['/addinstore'])
    this.renderer.removeClass(this.liView.nativeElement, 'selected');
    this.renderer.addClass(e.target.parentNode,"selected");
  }

  // gotoModule(e, path) { 
  //   if(path == "/addcampaign") {
  //     this.data.changeMessage("/ Add Campaign") 
  //   } else if(path == "/bulkcampaign") {
  //     this.data.changeMessage("/ Bulk Campaign") 
  //   } else if(path == "/addhoarding") {
  //     this.data.changeMessage("/ Add Hoarding") 
  //   } else if(path == "/bulkhoarding") {
  //     this.data.changeMessage("/ Bulk Hoarding") 
  //   } else if(path == "/map") {
  //     this.data.changeMessage("/ Map") 
  //   } else if(path == "/report") {
  //     this.data.changeMessage("/ Report") 
  //   } else if(path == "/calender") {
  //     this.data.changeMessage("/ Calender") 
  //   } else if(path == "/instorelist") {
  //     this.data.changeMessage("/ Instore List") 
  //   } else if(path == "/campaignlist") {
  //     this.data.changeMessage("/ Campaign List") 
  //   } else if(path == "/hoardinglist") {
  //     this.data.changeMessage("/ Hoarding List") 
  //   }

  //   this.router.navigate([path])
  //   this.renderer.removeClass(this.liView.nativeElement, 'selected');
  //   this.renderer.addClass(e.target.parentNode,"selected");
  // }
  
  /*addInformation(e,data){
    this.data.changeMessage("/ User Management") 
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "user": data
      }
    };

    this.router.navigate(['/usermanagement'],navigationExtras)
    this.renderer.removeClass(this.liView.nativeElement, 'selected');
    this.renderer.addClass(e.target.parentNode,"selected");
  } */
  
  gotoDashboard(e) {
    this.data.changeMessage("/ Dashboard")

    this.router.navigate(['/dashboard'])
    console.log("Parent:", e.target.parentNode); 
    this.renderer.removeClass(this.liView.nativeElement, 'selected');
    this.renderer.addClass(e.target.parentNode,"selected");
  }

  gotoInstoreBulk() {
    this.data.changeMessage("/ Instore Bulk Upload")
    this.router.navigate(['/bulkupload'])
  }

  closeResult :string
  openModal() {
    var userdata = localStorage.getItem('userInformation');
    var _data = JSON.parse(userdata);   
    this.confirmDialogService.confirmThis('Are you sure you want to logout now ?', () =>  {
      localStorage.removeItem('authtoken');
      if(_data && !_data.remember){
        localStorage.removeItem('userInformation');
      }
      localStorage.removeItem('lists');
      this.router.navigate(['/login'])
      }, () => {
        
      }); 
      }
    }

/*
    <script type="text/javascript">
        $(document).ready(function () {
            $('#sidebarCollapse').on('click', function () {
                $('#sidebar').toggleClass('active');
            });
        });
    </script>
*/    